import React, { MouseEventHandler, ReactNode } from 'react';
import cn from 'classnames';
import styles from './Header.module.scss';
import Group from '@repo/utils/models/Group';
import { pluralize } from '@repo/utils/helpers/string';

export const GroupMembershipCount = ({
  group,
  count,
  children,
}: {
  group?: Group;
  count?: number;
  children?: ReactNode;
}) => {
  const groupCount = Math.max(count || group?.count || 0, 0);
  return (
    <span className={cn(styles.groupMembershipCount, 'information')}>
      <span className="information-item">
        <span className="information-item-text">
          {groupCount} {pluralize(groupCount, 'Person')}
        </span>
      </span>
      {!group || !group?.created || group?.is_internal ? null : (
        <span className="information-item">{group?.created.format('MMM dd yyyy')}</span>
      )}
      {children}
    </span>
  );
};

export const GroupTitle = ({ group, onClick }: { group?: Group; onClick?: MouseEventHandler }) => (
  <h3 className={cn(styles.title, 'text-contact')} onClick={onClick}>
    {group.title}
  </h3>
);
